import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=1e53eee3&scoped=true"
import script from "./ShareButton.vue?vue&type=script&lang=ts"
export * from "./ShareButton.vue?vue&type=script&lang=ts"
import style0 from "./ShareButton.vue?vue&type=style&index=0&id=1e53eee3&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e53eee3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e53eee3')) {
      api.createRecord('1e53eee3', component.options)
    } else {
      api.reload('1e53eee3', component.options)
    }
    module.hot.accept("./ShareButton.vue?vue&type=template&id=1e53eee3&scoped=true", function () {
      api.rerender('1e53eee3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/ShareButton.vue"
export default component.exports